import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import PrintIcon from "@mui/icons-material/Print";
import ImageIcon from "@mui/icons-material/Image";
import DownloadIcon from "@mui/icons-material/Download";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import {
  Checkbox,
  Box,
  InputAdornment,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  NativeSelect,
  TextField,
  CircularProgress,
  TableSortLabel,
  Select,
  MenuItem,
  Stack,
  Button,
  Tooltip,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import PrintTwoToneIcon from "@mui/icons-material/PrintTwoTone";
import { useDispatch, useSelector } from "react-redux";
import CheckAndReturn from "../../../utility/CheckAndReturn";
import configServ from "../../../services/config";
import SearchBox from "../../Search/SearchBox";
import Constants from "../../../utility/Constants";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DateSelector from "../../DateSelector/DateSelector";
import useDebounce from "../../hooks/useDebounce";
import { useLocation, useNavigate } from "react-router-dom";
import { triggerLoader } from "../../../redux/reducers/LoaderTrigger";
import VoucherOrientation from "../../Voucher/VoucherOrientation";
import UploadImage from "../../Upload/UploadImage";
import CustomDateRangePicker from "../../DatePicker/CustomDateRangePicker";
import dayjs from "dayjs";
import useDeviceDetect from "../../Detect/useDeviceDetect ";
import LoaderNew from "../../Loader/LoaderNew";
import MobileView from "../../views/MobileView";
import DesktopView from "../../views/DesktopView";

//FUNCTION
export default function VoucherTable({ handleEditData, isChanged, isEdit }) {
  //#region code
  const navigate = useNavigate();
  const {
    user_id,
    company_id,
    is_super,
    companyName,
    companyAddress,
    companyState,
    companyCountry,
    is_admin,
    permissions,
  } = useSelector((state) => state.GlobalVariables);
  const dispatch = useDispatch();
  const rowsPerPageOptions = [10, 25, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);
  const [voucherList, setVoucherList] = useState([]);
  const [accountClassified, setAccountClassified] = useState([]);
  const [search, setSearch] = useState(null);
  const debounceSearch = useDebounce(search, 1000);
  const [searchBy, setSearchBy] = useState("customer_name");
  const [count, setCount] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("customer_name");
  const [loading, setLoading] = useState(true);
  const [fromDate, SetFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [isPrint, setIsPrint] = useState(false);
  const [isDownload, setIsDownload] = useState(false);
  const [printOpen, setPrintOpen] = useState(false);
  const [printData, setPrintData] = useState({});
  const [openImg, setOpenImg] = useState(false);
  const [Img, setImg] = useState("");
  const location = useLocation();
  const { entity_number, entity } = location.state || {};
  const [redirectVoucherNo, setRedirectVoucherNo] = useState(entity_number);
  const [entity_type, setEntity_type] = useState(entity ? entity : "customer");

  useEffect(() => {
    if (redirectVoucherNo) {
      setSearchBy("voucher_no");
      setSearch(redirectVoucherNo);
      fetchVoucherList("voucher_no", redirectVoucherNo);
    } else {
      setSearchBy("customer_name");
      setSearch("");
    }
  }, [redirectVoucherNo]);

  // Main fetch trigger
  useEffect(() => {
    if (!redirectVoucherNo) {
      fetchVoucherList();
    }
  }, [
    isChanged,
    page,
    order,
    orderBy,
    rowsPerPage,
    debounceSearch,
    entity_type,
  ]);

  // Reset page when debounceSearch, entity_type, or rowsPerPage changes
  useEffect(() => {
    if (!redirectVoucherNo) {
      setPage(0); // this will trigger fetch in next effect
    }
  }, [debounceSearch, entity_type]);

  const [dateRange, setDateRange] = useState([null, null]);
  useEffect(() => {
    if (dateRange[0] && dateRange[1]) {
      console.log("Start Date =", dayjs(dateRange[0]).format("YYYY-MM-DD"));
      console.log("End Date =", dayjs(dateRange[1]).format("YYYY-MM-DD"));
    }
  }, [dateRange]);

  useEffect(() => {
    if (!redirectVoucherNo && dateRange) {
      fetchVoucherList();
    }
  }, [dateRange]);

  const fetchVoucherList = async (searchByVch = null, VchNo = null) => {
    try {
      setLoading(true);
      const dataToSend = {
        is_super: is_super,
        user_id: user_id,
        company_id: company_id,
        search_by: searchByVch ? searchByVch : searchBy,
        search: VchNo ? VchNo : debounceSearch,
        per_page: rowsPerPage,
        page: page,
        sort_by: orderBy,
        order,
        entity_type: entity_type,
        // start_date: dayjs(dateRange[0]).format("YYYY-MM-DD"),
        // end_date: dayjs(dateRange[1]).format("YYYY-MM-DD"),
        start_date: dateRange[0]
          ? dayjs(dateRange[0]).format("YYYY-MM-DD")
          : "",
        end_date: dateRange[1] ? dayjs(dateRange[1]).format("YYYY-MM-DD") : "",
      };
      const res = await configServ.getVouchers(dataToSend);
      if (res.status === 200) {
        setVoucherList(res.data);
        setCount(res.total);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const headers = [
    { id: "fname", label: "Account" },
    { id: "voucher_no", label: "Voucher" },
    { id: "voucher_type", label: "Type" },
    { id: "date", label: "Date" },
    { id: "amount", label: "Amount" },
  ];

  const headerCellStyle = {
    fontSize: 14,
    fontWeight: "bold",
    backgroundColor: "#4CB5F5",
    color: "white",
  };

  const bodyCellStyle = {
    py: 0,
    my: 1,
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchBy = (event) => {
    try {
      setSearchBy(event.target.value);
    } catch (e) {
      console.log(e);
    }
  };

  const handleEdit = (params) => {
    const data = voucherList.filter((x) => x.id === params);
    handleEditData(data);
  };

  const handleImage = (params) => {
    try {
      const data = voucherList.find((x) => x.id === params);

      if (!data) {
        return;
      }

      if (data.extension === "pdf") {
        // Decode base64 string to binary
        const byteCharacters = atob(data.image);
        const byteNumbers = new Array(byteCharacters.length)
          .fill(0)
          .map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);

        // Create a Blob from the binary data
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const pdfURL = URL.createObjectURL(blob);

        // Open the Blob URL in a new tab
        window.open(pdfURL, "_blank");

        // Optional: Revoke the Object URL after some time
        setTimeout(() => URL.revokeObjectURL(pdfURL), 5000);
      } else if (data.is_image) {
        // Handle image
        const image = `data:image/${data.extension};base64,${data.image}`;
        setOpenImg(true);
        setImg(image);
      } else {
      }
    } catch (e) {
      console.log(e);
    }
  };

  const evenRowStyle = {
    background: "#f5f5f5",
  };

  const oddRowStyle = {
    background: "white",
  };

  const rowStyle = {
    "&:hover": {
      background: "#f1f9fe",
    },
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleEntityType = (params) => {
    try {
      const { name, value } = params.target;
      setEntity_type(value);
    } catch (e) {
      console.log(e);
    }
  };

  const cashVoucherRef = useRef();

  const handlePrintData = () => {
    setIsPrint(true);
  };

  useEffect(() => {
    if (isPrint === true) {
      handlePrint();
      setIsPrint(false);
    }
  }, [isPrint]);

  const handlePrint = useReactToPrint({
    content: () => cashVoucherRef.current,
    documentTitle: "Cash Vouchers",
  });

  const handleDownloadData = () => {
    setIsDownload(true);
  };

  useEffect(() => {
    if (isDownload === true) {
      handleDownload();
      setIsDownload(false);
    }
  }, [isDownload]);

  const handleDownload = () => {
    try {
      dispatch(triggerLoader());
      const input = cashVoucherRef.current;

      html2canvas(input, { scale: 1 }) // Adjust the scale to reduce resolution (e.g., 1 for lower resolution)
        .then((canvas) => {
          const imgData = canvas.toDataURL("image/jpeg", 0.75); // Use 'image/jpeg' and reduce quality (0.75 is 75% quality)
          const pdf = new jsPDF();
          const imgProps = pdf.getImageProperties(imgData);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

          pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight); // Use 'JPEG' instead of 'PNG'
          setTimeout(() => {
            pdf.save("CashVouchers.pdf");
            dispatch(triggerLoader());
          }, 5000);
        })
        .catch((e) => {
          console.log(e);
          dispatch(triggerLoader()); // Stop loader if there's an error
        });
    } catch (e) {
      console.log(e);
      dispatch(triggerLoader()); // Stop loader if there's an error in try block
    }
  };

  const handleCustomerClick = (params) => {
    try {
      const data = params;
      navigate("/account-master-entry/customers", { state: data });
    } catch (e) {
      console.log(e);
    }
  };

  const printVoucher = async (voucher) => {
    const data = {
      id: voucher.id,
      voucher_no: voucher.voucher_no,
      entity_id: voucher.entity_id,
      user_id: user_id,
      company_id: company_id,
      customer_id:voucher.customer_id,
    };
    setPrintOpen(true);
    setPrintData(data);
  };

  const handleVoucherPrint = (params) => {
    const data = voucherList.filter((x) => x.id === params.id);
    printVoucher(data[0]);
    // console.log("handleVoucherPrint",params)
  };

  const handleCloseImg = () => {
    setOpenImg(false);
  };

  //#endregion

  return (
    <Paper sx={{ width: "100%" }}>
      <UploadImage open={openImg} handleClose={handleCloseImg} Img={Img} />

      <VoucherOrientation
        open={printOpen}
        setOpen={setPrintOpen}
        data={printData}
      />

      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        spacing={1}
        direction="row"
        sx={{ mb: 1, flexWrap: "wrap" }}
      >
        {/* Left: Title */}
        <Grid item xs={12} md="auto">
          <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
            Voucher List: {count}
          </Typography>
        </Grid>

        {/* Date Range Picker */}
        {!redirectVoucherNo && (
          <Grid item xs={12} md="auto">
            <CustomDateRangePicker value={dateRange} onChange={setDateRange} />
          </Grid>
        )}

        {/* Entity Type Dropdown */}
        <Grid item xs={12} md="auto">
          <FormControl fullWidth size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Account Type</InputLabel>
            <Select
              fullWidth
              size="small"
              variant="standard"
              sx={{ background: "white" }}
              label="Type"
              name="entity_type"
              value={entity_type}
              onChange={handleEntityType}
            >
              {Constants.EntityTypes.map((item, index) => (
                <MenuItem key={index} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Search Filter */}
        {!redirectVoucherNo && (
          <>
            <Grid item xs={12} md="auto">
              <FormControl fullWidth>
                <InputLabel
                  variant="standard"
                  htmlFor="uncontrolled-native"
                  sx={{ ml: { xs: 2, md: 0 } }}
                >
                  Search By
                </InputLabel>
                <NativeSelect
                  defaultValue="customer_name"
                  onChange={handleSearchBy}
                  inputProps={{
                    name: "searchBy",
                    id: "uncontrolled-native",
                  }}
                >
                  <option value="customer_name">Account</option>
                  <option value="voucher_no">Voucher No</option>
                </NativeSelect>
              </FormControl>
            </Grid>

            <Grid item xs={12} md="auto">
              <SearchBox search={search} setSearch={setSearch} />
            </Grid>
          </>
        )}

        {/* Buttons: Download / Print / Refresh */}
        <Grid item xs={12} md="auto">
          <Stack direction="row" spacing={1} alignItems="center">
            {!redirectVoucherNo ? (
              <>
                <Button
                  variant="contained"
                  onClick={handleDownloadData}
                  startIcon={<DownloadIcon sx={{ ml: 2 }} />}
                  title="Download"
                  sx={{
                    backgroundColor: "#4bcf6b",
                    color: "white",
                    "&:hover": { backgroundColor: "#00b92f" },
                  }}
                />
                <Button
                  variant="contained"
                  onClick={handlePrintData}
                  startIcon={<PrintIcon sx={{ ml: 2 }} />}
                  title="Print"
                  sx={{
                    backgroundColor: "#349af1",
                    color: "white",
                    "&:hover": { backgroundColor: "#0868F8" },
                  }}
                />
              </>
            ) : (
              <Button
                variant="contained"
                title="Refresh"
                color="success"
                startIcon={<RefreshIcon sx={{ ml: 1, color: "white" }} />}
                onClick={() => setRedirectVoucherNo(null)}
              />
            )}
          </Stack>
        </Grid>
      </Grid>

      <MobileView>
        <Grid container alignItems={"center"} spacing={1} mt={1}>
          <Grid container item xs={6} md={6} justifyContent={"center"}>
            <FormControl fullWidth size="small">
              <InputLabel>Sort By</InputLabel>
              <Select
                fullWidth
                size="small"
                name="order_by"
                label="Sort By"
                value={orderBy}
                onChange={(e) => setOrderBy(e.target.value)}
                sx={{ background: "white" }}
              >
                {headers.map((item, index) => (
                  <MenuItem key={index} value={item.id}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid container item xs={6} md={6} justifyContent={"center"}>
            <FormControl fullWidth size="small">
              <InputLabel>Order</InputLabel>
              <Select
                fullWidth
                size="small"
                name="order"
                label="Order"
                value={order}
                onChange={(e) => setOrder(e.target.value)}
                sx={{ background: "white" }}
              >
                <MenuItem key={1} value={"asc"}>
                  {"Ascending"}
                </MenuItem>
                <MenuItem key={2} value={"desc"}>
                  {"Descending"}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ py: 2 }}>
          {loading ? (
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <LoaderNew />
            </Grid>
          ) : voucherList.length > 0 ? (
            voucherList.map((row, index) => (
              <Grid item xs={12} key={row.id}>
                <Paper elevation={3} sx={{ p: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {row.fname} -{" "}
                    <span
                      style={{
                        fontSize: "18px", // Adjust this size as needed (0.875rem is equivalent to 14px)
                        color: "gray", // A darker shade of text, you can adjust the hex code to your preference
                      }}
                    >
                      {row.address}
                    </span>
                  </Typography>

                  <Typography variant="body2" sx={{ color: "gray" }}>
                    <span style={{ fontWeight: "bold", color: "black" }}>
                      Voucher No:
                    </span>{" "}
                    {row.voucher_no}
                  </Typography>

                  <Typography variant="body2" sx={{ color: "gray" }}>
                    <span style={{ fontWeight: "bold", color: "black" }}>
                      {" "}
                      Type:
                    </span>{" "}
                    {row.voucher_type}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "gray" }}>
                    <span style={{ fontWeight: "bold", color: "black" }}>
                      {" "}
                      Date:
                    </span>{" "}
                    {CheckAndReturn.transformToDate3(row.date)}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "gray" }}>
                    <span style={{ fontWeight: "bold", color: "black" }}>
                      {" "}
                      Amount:
                    </span>{" "}
                    ₹{row.amount}
                  </Typography>
                  <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                    <Box
                      display={
                        Boolean(
                          is_super || is_admin || permissions.includes(29)
                        )
                          ? "block"
                          : "none"
                      }
                    >
                      <Tooltip title="Edit" placement="top">
                        <IconButton onClick={() => handleEdit(row.id)}>
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                    <Box>
                      <Tooltip
                        title={
                          row.extension === "pdf" ? "PDF File" : "Preview Image"
                        }
                        placement="top"
                      >
                        <IconButton
                          disabled={
                            !Boolean(row.is_image) && row.extension !== "pdf"
                          }
                          onClick={() => handleImage(row.id)}
                          style={{
                            color:
                              !Boolean(row.is_image) && row.extension !== "pdf"
                                ? "red"
                                : "inherit", // Red color when disabled
                          }}
                        >
                          {row.extension === "pdf" ? (
                            <PictureAsPdfIcon />
                          ) : !Boolean(row.is_image) &&
                            row.extension !== "pdf" ? (
                            // Show a red CancelScheduleSendIcon when disabled
                            <CancelScheduleSendIcon style={{ color: "red" }} />
                          ) : (
                            <img
                              src={`data:image/${row.extension};base64,${row.image}`}
                              alt="Preview"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "5px",
                              }}
                            />
                          )}
                        </IconButton>
                      </Tooltip>
                    </Box>
                    <Box>
                      <Tooltip title="Print" placement="top">
                        <IconButton onClick={() => handleVoucherPrint(row)}>
                          <PrintTwoToneIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Stack>
                </Paper>
              </Grid>
            ))
          ) : (
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Box sx={{ color: "red", fontWeight: 600 }}>No data found.</Box>
            </Grid>
          )}
        </Grid>
        {!loading && voucherList.length > 0 && (
          <Box>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
        )}
      </MobileView>

      <DesktopView>
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100vh", // Set full height
            // display: { xs: "none", sm: "none", lg: "block" },
          }}
          ref={cashVoucherRef}
        >
          {(isPrint || isDownload) && (
            <>
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: 600,
                  textAlign: "center",
                }}
              >
                {companyName}
              </Typography>
              <Typography sx={{ textAlign: "center" }}>
                {companyAddress}, {companyState}, {companyCountry}
              </Typography>
            </>
          )}
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={headerCellStyle}>S.No.</TableCell>
                {headers.map((column) => (
                  <TableCell
                    key={column.id}
                    sortDirection={orderBy === column.id ? order : false}
                    sx={headerCellStyle}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={() => handleRequestSort(column.id)}
                    >
                      {column.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
                <TableCell sx={headerCellStyle}>Action</TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableRow>
                <TableCell colSpan={12} sx={{ textAlign: "center" }}>
                  <div>
                    <LoaderNew />
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              <TableBody>
                {voucherList.length > 0 ? (
                  voucherList.map((row, index) => {
                    return (
                      <TableRow
                        key={row.id}
                        sx={{
                          ...rowStyle,
                          ...(index % 2 === 0 ? evenRowStyle : oddRowStyle),
                        }}
                      >
                        <TableCell sx={bodyCellStyle}>
                          {page * rowsPerPage + index + 1}
                        </TableCell>
                        <TableCell sx={bodyCellStyle}>
                          {entity_type === "customer" ? (
                            <span
                              className="linkStyle"
                              onClick={() => handleCustomerClick(row.fname)}
                            >
                              {row.fname}
                            </span>
                          ) : (
                            <span>{row.fname}</span>
                          )}
                          -<span style={{ color: "gray" }}>{row.address}</span>
                        </TableCell>
                        <TableCell sx={bodyCellStyle}>
                          {row.voucher_no}
                        </TableCell>
                        <TableCell sx={bodyCellStyle}>
                          {row.voucher_type}
                        </TableCell>
                        <TableCell sx={bodyCellStyle}>
                          {CheckAndReturn.transformToDate3(row.date)}
                        </TableCell>
                        <TableCell sx={bodyCellStyle}>₹{row.amount}</TableCell>
                        <TableCell sx={bodyCellStyle}>
                          <Stack direction={"row"}>
                            <Tooltip
                              title="Edit"
                              placement="top"
                              sx={{
                                display: Boolean(
                                  is_super ||
                                    is_admin ||
                                    permissions?.includes(29)
                                )
                                  ? "block"
                                  : "none", // Show/Hide based on the condition
                              }}
                            >
                              <IconButton onClick={() => handleEdit(row.id)}>
                                <EditIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip
                              title={
                                row.extension === "pdf"
                                  ? "PDF File"
                                  : "Preview Image"
                              }
                              placement="top"
                            >
                              <IconButton
                                disabled={
                                  !Boolean(row.is_image) &&
                                  row.extension !== "pdf"
                                }
                                onClick={() => handleImage(row.id)}
                                style={{
                                  color:
                                    !Boolean(row.is_image) &&
                                    row.extension !== "pdf"
                                      ? "red"
                                      : "inherit", // Red color when disabled
                                }}
                              >
                                {row.extension === "pdf" ? (
                                  <PictureAsPdfIcon />
                                ) : !Boolean(row.is_image) &&
                                  row.extension !== "pdf" ? (
                                  // Show a red CancelScheduleSendIcon when disabled
                                  <CancelScheduleSendIcon
                                    style={{ color: "red" }}
                                  />
                                ) : (
                                  <img
                                    src={`data:image/${row.extension};base64,${row.image}`}
                                    alt="Preview"
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "5px",
                                    }}
                                  />
                                )}
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Print" placement="top">
                              <IconButton
                                onClick={() => handleVoucherPrint(row)}
                              >
                                <PrintTwoToneIcon />
                              </IconButton>
                            </Tooltip>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={12} sx={{ textAlign: "center" }}>
                      <Box sx={{ color: "red", fontWeight: 600 }}>
                        No data found.
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </DesktopView>
    </Paper>
  );
}
